
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"12","viewBox":"0 0 21 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.0281 1.28418H7.67578V10.7131H13.0281V1.28418Z","fill":"#FF5F00"}}),_c('path',{attrs:{"d":"M8.01617 5.99861C8.01617 4.16613 8.88274 2.41694 10.344 1.28413C7.69333 -0.764925 3.83623 -0.315134 1.74627 2.30032C-0.326711 4.89912 0.132063 8.66404 2.79974 10.7131C5.02564 12.429 8.13511 12.429 10.361 10.7131C8.88274 9.58029 8.01617 7.8311 8.01617 5.99861Z","fill":"#EB001B"}}),_c('path',{attrs:{"d":"M20.2509 5.99861C20.2509 9.31374 17.5153 11.9958 14.134 11.9958C12.7576 11.9958 11.4323 11.546 10.3618 10.7131C13.0125 8.66405 13.4713 4.89912 11.3813 2.28366C11.0755 1.91717 10.7356 1.56733 10.3618 1.28413C13.0125 -0.764925 16.8696 -0.315134 18.9426 2.30032C19.7922 3.34984 20.2509 4.64924 20.2509 5.99861Z","fill":"#F79E1B"}})])
          )
        }
      }
    